import { stylesheet } from 'typestyle';
import { colors, font, spacers } from '../../assets/styles';

const drawerHeight = '180px';

const styles = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: spacers.pageMargin,
    paddingTop: '50px',
    paddingBottom: '40px',
  },
   header: {
    color: colors.foreground,
    fontWeight: font.weight.bold,
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '-0.15px',
    textAlign: 'center',
    marginBottom: '6px',
  },
  subHeader: {
    color: colors.foregroundLighter,
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: 40,
    paddingLeft: 2,
    paddingRight: 2,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerLeftIcon: {
    height: 24,
    width: 24,
    marginRight: 16,
  },
  headerText: {
    fontWeight: font.weight.regular,
    fontSize: 20,
  },
  headerRight: {
    textAlign: 'end',
  },
  infoIcon: {
    width: 40,
    height: 'auto',
  },
  button: {
    fontSize: '16px !important',
    fontWeight: font.weight.bold,
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  buttonWithIcon: {
    border: 'none',
    display: 'flex',
    padding: '5px 10px',
    background: 'none',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contactsLookupWrapper: {
    padding: '20px 10px 0 10px',
    position: 'sticky',
    top: 0,
    background: 'white',
  },
  displayFlexWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  searchBar: {
    appearance: 'none',
    boxShadow: 'none',
    borderRadius: 'none',
    display: 'flex',
    padding: '10px 10px 10px 30px',
    border: '1px solid #202737'
  },
  contactsWrapper: {
    padding: '0 10px',
    flex: 1,
  },
  subTitle: {
    color: 'white',
    lineHeight: '24px',
    fontWeight: 300,
    fontSize: 14,
  },
  entryPointImage: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  scheduleWrapper: {
    fontWeight: font.weight.bold,
    fontSize: '16px',
    lineHeight: '19px',
    // @ts-ignore
    letter: '-0.12px',
    textAlign: 'center',
    marginTop: 34,
  },
  schedule: {
    fontWeight: font.weight.regular,
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center',
    marginTop: 6,
  },
  time: {
    color: colors.foreground,
    fontWeight: font.weight.bold,
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '-0.18px',
    marginTop: 8,
    marginBottom: 30,
  },
  description: {
    color: colors.foregroundLighter,
    fontSize: 16,
    lineHeight: '22px',
  },
  content: {
    margin: '20px',
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 32,
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    width: 40,
  },
  bottomDrawer: {
    // bottom: `-${drawerHeight}`,
    // height: drawerHeight,
    transform: `translateY(-${drawerHeight})`,
  },
  spacer: {
    padding: '15px 0 0 15px',
  },
  contentBottom: {
    display: 'flex',
    padding: '0 5% 5% 5%',
    justifyContent: 'center',
    // alignItems: 'center',
    // textAlign: 'center',
    flexDirection: 'column',
  }
});

export default styles;
